"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsFormatStyle = void 0;
/**
 * Enumeration of the styles in which points amounts can be displayed.
 */
var PointsFormatStyle;
(function (PointsFormatStyle) {
    /**
     * Displaying the amount and making it clear that it is an amount of points.
     */
    PointsFormatStyle["DEFAULT"] = "default";
    /**
     * For situations where the number is implicitly a point amount, so a symbol is not required.
     */
    PointsFormatStyle["IMPLICIT"] = "implicit";
})(PointsFormatStyle = exports.PointsFormatStyle || (exports.PointsFormatStyle = {}));
//# sourceMappingURL=points-format-style.enum.js.map